import { AlertColor, SnackbarOrigin } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { Dispatch, ReactNode } from "react";
import { ButtonItem } from "../../routes/buttons/ButtonsData";
import { IJob } from "../../routes/dispatch-availability-list-report/DispatchAvailabilityListReportData";

export const OPEN_TOAST = "OPEN_TOAST";

export const CLOSE_TOAST = "CLOSE_TOAST";

export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const RESET_DATE_RANGE = 'RESET_DATE_RANGE';

export const SET_PREV_LOCATION = 'SET_PREV_LOCATION';

export const SET_DATE = 'SET_DATE';

export const RESET_DATE = 'RESET_DATE';

export const SET_SHIFT = 'SET_SHIFT';

export const RESET_SHIFT = 'RESET_SHIFT';

export const SET_JOB = 'SET_JOB';

export const RESET_JOB = 'RESET_JOB';

export const SET_EMAIL_SUBMITTED = 'SET_EMAIL_SUBMITTED';

export const RESET_EMAIL_SUBMITTED = 'RESET_EMAIL_SUBMITTED';

export const SET_CURRENT_BUTTON = 'SET_CURRENT_BUTTON';

export const RESET_CURRENT_BUTTON = 'RESET_CURRENT_BUTTON';

export interface IToast {
  severity?: AlertColor;
  msg?: string | JSX.Element;
  open?: boolean;
  title?: string | JSX.Element;
  closeTime?: number;
  anchorOrigin?: SnackbarOrigin;
  action?: ReactNode;
}

export interface GlobalState {
  toast: IToast;
  dateRange: DateRange;
  dateValue: Dayjs,
  previousLocation: string | undefined;
  shift: string;
  job: IJob;
  emailSubmitted: boolean;
  button: ButtonItem | null;
}

export type DateRange = [Dayjs | null, Dayjs | null];

export type GlobalStateAction =
  { type: typeof OPEN_TOAST, payload: IToast } |
  { type: typeof CLOSE_TOAST } |
  { type: typeof SET_DATE_RANGE, payload: DateRange } |
  { type: typeof RESET_DATE_RANGE } |
  { type: typeof SET_PREV_LOCATION, payload: string | undefined } |
  { type: typeof SET_DATE, payload: Dayjs } |
  { type: typeof RESET_DATE } |
  { type: typeof SET_SHIFT, payload: string } |
  { type: typeof RESET_SHIFT } |
  { type: typeof SET_JOB, payload: IJob } |
  { type: typeof RESET_JOB } |
  { type: typeof SET_EMAIL_SUBMITTED, payload: boolean } |
  { type: typeof RESET_EMAIL_SUBMITTED } |
  { type: typeof SET_CURRENT_BUTTON, payload: ButtonItem } |
  { type: typeof RESET_CURRENT_BUTTON, payload: ButtonItem }

export const defaultToast: IToast = {
  severity: "success",
  msg: '',
  open: false,
  title: '',
  closeTime: 2000
}

export const defaultDateRange: DateRange = [null, null];

export const defaultDate: Dayjs = dayjs();

export const defaultShift: string = "1";

export const defaultJob: IJob = {
  jobId: 3821,
  jobDescription: "40 TON"
};

export const defaultEmailSubmitted = false;

export const defaultGlobalState = {
  toast: defaultToast,
  dateRange: defaultDateRange,
  dateValue: defaultDate,
  previousLocation: undefined,
  shift: defaultShift,
  job: defaultJob,
  emailSubmitted: defaultEmailSubmitted,
  button: null,
} as GlobalState;

export interface GlobalContextValue {
  state: GlobalState,
  dispatch: Dispatch<GlobalStateAction>
}